module.exports = __webpack_public_path__ + "static/media/maya.275e78a4.jpeg";